(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bulldog-blog').forEach((section) => {
    const track = section.querySelector('[data-blog-track]');
    const cards = Array.from(section.querySelectorAll('.bulldog-blog__card'));
    const dots = Array.from(section.querySelectorAll('[data-blog-dot]'));
    if (!track || cards.length === 0 || dots.length === 0) return;

    const updateDots = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let activeIndex = 0;
      let shortestDistance = Infinity;
      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(center - cardCenter);
        if (distance < shortestDistance) {
          shortestDistance = distance;
          activeIndex = index;
        }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        cards[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    track.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bulldog-trust').forEach((section) => {
    const track = section.querySelector('[data-trust-track]');
    const items = Array.from(section.querySelectorAll('.bulldog-trust__item'));
    const dots = Array.from(section.querySelectorAll('.bulldog-trust__dot'));
    if (!track || items.length < 2 || dots.length === 0) return;

    const update = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let active = 0;
      let distance = Infinity;
      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const current = Math.abs(center - itemCenter);
        if (current < distance) {
          distance = current;
          active = index;
        }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    };

    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bulldog-about').forEach((section) => {
    const more = section.querySelector('[data-about-more]');
    const button = section.querySelector('[data-about-toggle]');
    const label = section.querySelector('[data-about-label]');
    if (!more || !button || !label) return;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      more.classList.toggle('is-expanded', !expanded);
      label.textContent = expanded ? button.dataset.openLabel : button.dataset.closeLabel;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bulldog-categories').forEach((section) => {
    const track = section.querySelector('[data-bulldog-category-track]');
    const cards = Array.from(section.querySelectorAll('.bulldog-categories__card'));
    const dots = Array.from(section.querySelectorAll('.bulldog-categories__dot'));
    if (!track || cards.length < 2 || dots.length === 0) return;

    const updateDots = () => {
      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;
      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const distance = Math.abs(trackCenter - cardCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
    };

    track.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["number-counter"] && !Shopify.designMode) return;
  try {
    
  /* BDK_NEW_AJAX_2026_10_01 : ajout en arrière-plan + tiroir MoonBundle, jamais la page panier */
  if (!window.__bdkNewAjax) {
    window.__bdkNewAjax = true;
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest && event.target.closest('.bulldog-new__form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('.bulldog-new__add');
      if (button) { if (button.disabled) return; button.disabled = true; }
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('cart/add ' + response.status);
        if (typeof window.openMoonBundleCartDrawer === 'function') window.openMoonBundleCartDrawer();
        else window.location.href = '/cart';
      } catch (error) {
        form.submit();
      } finally {
        if (button) button.disabled = false;
      }
    });
  }

  document.querySelectorAll('.bulldog-new').forEach((section) => {
    section.querySelectorAll('.bulldog-new__card').forEach((card) => {
      const select = card.querySelector('.bulldog-new__select');
      if (!select) return;

      const price = card.querySelector('[data-variant-price]');
      const compare = card.querySelector('[data-variant-compare]');
      const saving = card.querySelector('[data-variant-saving]');
      const addButton = card.querySelector('.bulldog-new__add');
      const addLabel = card.querySelector('[data-add-label]');

      const updateVariant = () => {
        const option = select.options[select.selectedIndex];
        if (!option) return;

        if (price) price.textContent = option.dataset.price || '';

        const comparePrice = option.dataset.comparePrice || '';
        if (compare) {
          compare.textContent = comparePrice;
          compare.hidden = !comparePrice;
        }

        const savingValue = option.dataset.saving || '';
        if (saving) {
          saving.textContent = savingValue;
          saving.hidden = !savingValue;
        }

        const available = option.dataset.available === 'true';
        if (addButton) addButton.disabled = !available;
        if (addLabel) addLabel.textContent = available ? 'Choisir ce pack' : 'Épuisé';
      };

      select.addEventListener('change', updateVariant);
      updateVariant();
    });

    const slider = section.querySelector('[data-slider]');
    const previous = section.querySelector('[data-slider-prev]');
    const next = section.querySelector('[data-slider-next]');
    if (!slider || !previous || !next) return;
    const move = (direction) => {
      const card = slider.querySelector('.bulldog-new__card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(slider).gap) || 0;
      slider.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    

  /* BDK_NEW_AJAX_2026_10_01 : ajout en arrière-plan + tiroir MoonBundle, jamais la page panier */

  if (!window.__bdkNewAjax) {

    window.__bdkNewAjax = true;

    document.addEventListener('submit', async (event) => {

      const form = event.target.closest && event.target.closest('.bulldog-new__form');

      if (!form) return;

      event.preventDefault();

      const button = form.querySelector('.bulldog-new__add');

      if (button) { if (button.disabled) return; button.disabled = true; }

      try {

        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });

        if (!response.ok) throw new Error('cart/add ' + response.status);

        if (typeof window.openMoonBundleCartDrawer === 'function') window.openMoonBundleCartDrawer();

        else window.location.href = '/cart';

      } catch (error) {

        form.submit();

      } finally {

        if (button) button.disabled = false;

      }

    });

  }



  document.querySelectorAll('.bulldog-new').forEach((section) => {

    section.querySelectorAll('.bulldog-new__card').forEach((card) => {

      const select = card.querySelector('.bulldog-new__select');

      if (!select) return;



      const price = card.querySelector('[data-variant-price]');

      const compare = card.querySelector('[data-variant-compare]');

      const saving = card.querySelector('[data-variant-saving]');

      const addButton = card.querySelector('.bulldog-new__add');

      const addLabel = card.querySelector('[data-add-label]');



      const updateVariant = () => {

        const option = select.options[select.selectedIndex];

        if (!option) return;



        if (price) price.textContent = option.dataset.price || '';



        const comparePrice = option.dataset.comparePrice || '';

        if (compare) {

          compare.textContent = comparePrice;

          compare.hidden = !comparePrice;

        }



        const productHasBogo = saving.dataset.productBogo === 'true';

        const savingValue = option.dataset.bogo === 'true'

          ? 'X2'

          : (productHasBogo ? '' : (option.dataset.saving || ''));

        if (saving) {

          saving.textContent = savingValue;

          saving.hidden = !savingValue;

        }



        const available = option.dataset.available === 'true';

        if (addButton) addButton.disabled = !available;

        if (addLabel) addLabel.textContent = available ? 'Ajouter au panier' : 'Épuisé';

      };



      select.addEventListener('change', updateVariant);

      updateVariant();

    });



    const slider = section.querySelector('[data-slider]');

    const previous = section.querySelector('[data-slider-prev]');

    const next = section.querySelector('[data-slider-next]');

    if (!slider || !previous || !next) return;

    const move = (direction) => {

      const card = slider.querySelector('.bulldog-new__card');

      if (!card) return;

      const gap = Number.parseFloat(getComputedStyle(slider).gap) || 0;

      slider.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });

    };

    previous.addEventListener('click', () => move(-1));

    next.addEventListener('click', () => move(1));

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bulldog-reviews').forEach((section) => {
    const track = section.querySelector('[data-review-track]');
    const previous = section.querySelector('[data-review-prev]');
    const next = section.querySelector('[data-review-next]');
    if (!track || !previous || !next) return;

    const move = (direction) => {
      const item = track.querySelector('.bulldog-reviews__item');
      if (!item) return;
      const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();
})();
